import { Grid, Tab, Tabs, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ArticlesSettingTable from "./components/ArticlesSettingTable";
import StoreSettingTable from "./components/StoreSettingTable";

const AdminSettings = () => {
  const { t } = useTranslation();

  const [tabValue, setTabValue] = useState(1);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box padding="24px">
      <Stack direction="column">
        <Grid display="flex" justifyContent="center" padding="24px 0">
          <Typography variant="h5">{t("adminSettings.title")}</Typography>
        </Grid>
        <Box sx={{ width: "100%" }}>
          <Stack direction="row" display="flex" justifyContent="space-between">
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="secondary tabs example"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#F40002",
                  height: 3,
                },
                "& .MuiTab-root.Mui-selected": {
                  color: "#F40002",
                },
              }}
            >
              <Tab value={1} label={t("adminSettings.articleSetting")} />
              <Tab value={2} label={t("adminSettings.storeSetting")} />
            </Tabs>
          </Stack>
          {tabValue === 1 && <ArticlesSettingTable />}
          {tabValue === 2 && <StoreSettingTable />}
        </Box>
      </Stack>
    </Box>
  );
};

export default AdminSettings;
